import { createFileRoute } from '@tanstack/react-router';
import { AccountPage } from '../components/pages/AccountPage/AccountPage';

export const Route = createFileRoute('/account/$accountId')({
  component: AccountPage,
});
